import React, { FunctionComponent, SVGProps } from 'react';
import { ColorScheme, ILogoColorSchemeProps } from 'app/components/svgs/logos/constants';

const SvgEngooLogo: FunctionComponent<SVGProps<SVGSVGElement> & ILogoColorSchemeProps> = ({
  colorScheme = ColorScheme.Dark,
  ...svgProps
}) => (
  <svg viewBox="0 0 448 156" fill="none" {...svgProps}>
    <g clipPath="url(#id3902098177__clip0)" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M167.53 69.02h.02c-.15-20.46-16.75-37-37.22-37-20.46 0-37.06 16.54-37.22
           37v44.57c0 4.95 4.12 8.97 9.07 8.97 4.8 0 8.61-3.64 8.83-8.39V68.84c.61-10.16
           9.02-18.22 19.32-18.22 10.36 0 18.82 8.15 19.34 18.4v44.92h.04a8.95 8.95
           0 0 0 8.94 8.62c4.94 0 8.9-4.02 8.9-8.97l-.02-44.57"
        fill={colorScheme === ColorScheme.Dark ? '#404040' : '#FFFFFF'}
      />
      <path d="M330.61 69.2a5.52 5.52 0 0 1-9.41 3.9 5.51 5.51 0 1 1 9.41-3.9" fill="#009CFF" />
      <path d="M408.18 69.2a5.52 5.52 0 1 1-11.03 0 5.52 5.52 0 0 1 11.03 0" fill="#FF3651" />
      <path
        d="M316.67 104.6c-10.02 0-18.23-7.63-19.18-17.4h.02l-.02-18.7c.61-10.12 8.92-18.13
           19.18-18.13 10.32 0 18.75 8.1 19.26 18.3h.01V86.3c-.52 10.2-8.95 18.3-19.27
           18.3zm43.65-12.98l-6.59-16.7v-6.25h.03c-.16-20.35-16.7-36.8-37.1-36.8-20.38
           0-36.92 16.45-37.08 36.8V86.3c.16 20.36 16.7 36.8 37.09 36.8 17.58 0 32.28-12.22
           36.11-28.63h4.87c3.74 0 2.67-2.85 2.67-2.85z"
        fill="#009CFF"
      />
      <path
        d="M410.06 104.6c-10.01 0-18.3-7.63-19.24-17.4l.09-18.7c.6-10.12 8.9-18.13 19.15-18.13
           10.33 0 18.75 8.1 19.27 18.3V86.3c-.52 10.2-8.94 18.3-19.26
           18.3zm37.1-35.93c-.16-20.35-16.7-36.8-37.1-36.8-20.38 0-36.93 16.45-37.08 36.8l.14 5.77-6.79
           17.18s-1.06 2.85 2.67 2.85h4.95c3.83 16.4 18.54 28.64 36.12 28.64 20.08 0 36.46-15.98 37.08-35.91V68.67z"
        fill="#F64C58"
      />
      <path
        d="M17.96 68.31C18.66 58.3 27 50.37 37.2 50.37c10.2 0 18.54 7.92 19.23
           17.94H17.96zm56.3-.35c-.54-20.02-16.92-36.1-37.07-36.1S.66 47.95.13
           67.97l.02 19.57C.94 107.3 17.2 123.1 37.19 123.1c9.34 0 17.87-3.46
           24.39-9.16 2.29-1.94 4.49-4.55 4.49-7.92a9.25 9.25 0 0 0-9.25-9.25c-2.42
           0-4.74.94-6.46 2.64a19.22 19.22 0 0 1-13.17 5.19c-10.32
           0-18.75-8.39-19.26-18.58h48.2c4.34-.53 7.8-4.06 8.13-8.46v-9.61zm149.02
           19c-10.32 0-18.75-8.1-19.27-18.3.52-10.19 8.95-18.29 19.27-18.29s18.75
           8.1 19.26 18.3c-.51 10.19-8.94 18.3-19.26
           18.3zm37.09-18.3c-.17-20.34-16.7-36.8-37.1-36.8-20.38 0-36.92 16.46-37.08
           36.81.16 20.35 16.7 36.8 37.09 36.8a36.9 36.9 0 0 0 19.27-5.4v5.98c-.52
           10.2-8.95 18.3-19.27 18.3-5.07 0-10.51-2.79-13.19-5.1-1.97-1.71-4.22-3.26-7.03-3.26a9.25 9.25
           0 0 0-9.26 9.25c0 3.36 1.97 6.04 4.47 7.91 7.16 5.35 15.37 9.7 25 9.7 20.4
           0 36.94-16.44 37.1-36.8h-.03l.03-37.39z"
        fill={colorScheme === ColorScheme.Dark ? '#404040' : '#FFFFFF'}
      />
    </g>
    <defs>
      <clipPath id="id3902098177__clip0">
        <path fill="#fff" d="M0 0h447.02v155.39H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEngooLogo;
